import {SubPageHeader} from "../SubPageHeader";
import React from "react";
import './OurMission.css'
import Footer from "../Footer";

function OurMission() {
    return (
        <>
            <SubPageHeader title='Our Mission'/>
            <div className='sub-page-container'>
                <div className='sub-page-content'>
                    <p><b>Evangelism:</b> To present the Gospel of Jesus Christ in such a way that turns non-Christians into converts,</p>

                    <p><b>Edification:</b> converts and de churched into disciples,</p>

                    <p><b>Equipping:</b> disciples into mature fruitful leaders,</p>

                    <p><b>Extension:</b> who will in turn go into our city and the world and reach others for Christ.</p>
                </div>
            </div>
            <Footer/>
            }
        </>
    )
}

export default OurMission;